module.exports = __webpack_public_path__ + "static/img/015.64819c7d.png";